import { useEffect } from "react";
import { useAssistantNanooxRegistry } from "./viewContextStore";

export default function useAssistantNanooxContext(descriptor) {
  const registry = useAssistantNanooxRegistry();

  useEffect(() => {
    if (!registry) return undefined;

    registry.setRegisteredNanooxContext(descriptor || null);

    return () => {
      registry.clearRegisteredNanooxContext();
    };
  }, [descriptor, registry]);
}
